module.exports = __webpack_public_path__ + "static/media/netball-ground.6e42a9cd.jpg";